'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdStopScreenShare = function MdStopScreenShare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 25q2.3-3.1 6.1-4.1l-2.6-2.6q-2.5 2.4-3.5 6.7z m-7.6-22.1l32.9 32.9-2.1 2.1-4.6-4.5h-30.2v-3.4h6.6q-1.4 0-2.3-1t-0.9-2.3v-16.7q0-1.5 1.1-2.4l-2.6-2.6z m32.6 23.8q0 2-1.7 2.9l-9.2-9.2 2.7-2.5-6.8-6.2v3.5q-0.1 0.1-0.4 0.1t-0.4 0.1l-8.8-8.7h21.4q1.3 0 2.3 1t0.9 2.3v16.7z m-1.2 3.3h4.6v3.4h-1.3z' })
        )
    );
};

exports.default = MdStopScreenShare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/stop-screen-share.js
// module id = 3822
// module chunks = 168707334958949